import { ApiResult } from 'interfaces/APITypes';
import { Partner } from 'interfaces/user/Partner';

import { makeRequest, mytoverInstance } from './client';

export const getPartners = async (): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/partners'));
};

export const getPartner = async (id: number | string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get(`/partners/${id}`));
};

export const updatePartner = async ({ id, update }: { id: number; update: any | null }): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.patch(`/partners/${id}`, update));
};

export const getPartnerUsers = async (partner: number): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get(`/partners/${partner}/users`));
};

export const getPartnerUnits = async (partner: number, values: any): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get(`/partners/${partner}/units`, { params: values }));
};

export const unlinkPartnerUser = async (partner: number, userId: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.delete(`/partners/${partner}/users/${userId}`));
};

export const verifyPartnerEmailDomain = async (partner: Partner): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post(`/partners/${partner.id}/verify-domain`));
};
